import React  from 'react';
import { connect } from 'react-redux';
import VisitInfo from './VisitInfo';
import combinedShape from './images/combined-shape.svg';
 
const VisitInfoList = (props) =>  {
 
    return (
        <div className="visit-info-list">
            <div className="title">
                <span className="icon" style={{backgroundImage:combinedShape.bg()}}></span>
            </div>
            <div className="visit-list">
                {props.technicianVisits.map((item, i) => (
                    <VisitInfo key={i} visit={item} onClickUpdateVisitBtn={props.onClickUpdateVisitBtn} onClickCancelVisitBtn={props.onClickCancelVisitBtn} />
                ))}
            </div>                
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
      technicianVisits : state.technicianUpdatesBlock.technicianVisits
    };
  };
  
  const mapDispatchToProps = {
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(VisitInfoList);